'use strict'

module.exports = require('./lib/encode-hexadecimal')
